import { useEffect, useState } from "react"
import { Link } from "react-router-dom";
import planos from "./planosSkyFit.js";

import Footer from "../../components/footer/index.js"
import "./unidadeSkyFit.css"

import academia from "../../../assets/general_assets/Itaipava.jpg"
import teamcrezio from "../../../assets/general_assets/logo-faixa.png"
import begginner from "../../../assets/home_assets/Jiu Jitsu Iniciantes_.jpg"
import woman from "../../../assets/home_assets/Boxe Feminino_.jpg"
import kids from "../../../assets/home_assets/Jiu Jitsu Teens.jpg"
import teacher from "../../../assets/home_assets/tets sp.jpg"
import professores from "../../../assets/general_assets/triade.png"
import responsable from "../../../assets/general_assets/miguelUnitImg.png"
import responsable_logo from "../../../assets/general_assets/logo-sem-fundo-site.png"
import skyfitlogo from "../../../assets/general_assets/skyfit_logo.png"
import schedule from "../../../assets/general_assets/scheduleskyfit.jpeg"

import build1 from "../../../assets/general_assets/retiro1.jpg"
import build2 from "../../../assets/general_assets/retiro2.jpg"
import build3 from "../../../assets/general_assets/retiro3.jpg"
import build4 from "../../../assets/general_assets/retiro4.jpg"
import build5 from "../../../assets/general_assets/retiro5.jpg"
import build6 from "../../../assets/general_assets/retiro6.jpg"
import build7 from "../../../assets/general_assets/retiro7.jpg"
import build8 from "../../../assets/general_assets/retiro8.jpg"
import build9 from "../../../assets/general_assets/retiro9.jpg"
import build10 from "../../../assets/general_assets/retiro10.jpg"

export default function UnidadesSkyFit() {

    const [modalidade, setModalidade] = useState('');
    const [buildingImg, setBuildingImg] = useState(build5);

    const imgList = [
        build1,
        build2,
        build3,
        build4,
        build5,
        build6,
        build7,
        build8,
        build9,
        build10
    ]

    useEffect(() => {

        const elements = {
            home_img: document.getElementById('home_image'),
            begginner: document.getElementById('begginner'),
            woman: document.getElementById('woman'),
            kid: document.getElementById('kid'),
            teacher: document.getElementById('teacher'),
            planOptions: document.getElementById('planOptions'),
            planOptionsPromo: document.getElementById('planOptionsPromo'),
            planText: document.getElementById('planText'),
            prof_text: document.getElementById('prof-p'),
            prof_img: document.getElementById('prof-img'),
            building_text: document.getElementById('building_text'),
            building_img: document.getElementById('building_img'),
            resp_text: document.getElementById('resp_text'),
            resp_logo: document.getElementById('resp_logo'),
            socials: document.getElementById('socials')
        };

        const handleScroll = () => {
            const y = window.scrollY;

            if (y > 50 && elements.home_img)
                elements.home_img.classList.add("minimized");

            if (y > 250) {
                elements.begginner?.classList.add("card_fade-in");
                elements.woman?.classList.add("card_fade-in");
                elements.kid?.classList.add("card_fade-in");
                elements.teacher?.classList.add("card_fade-in");
            }

            if (y > 600) {
                elements.planOptions?.classList.add("card_fade-in");
                elements.planOptionsPromo?.classList.add("card_fade-in");
                elements.planText?.classList.add("fade-in");
            }

            if (y > 1300) {
                elements.prof_text?.classList.add('fade-in');
                elements.prof_img?.classList.add('card_fade-in');
            }

            if (y > 1800) {
                elements.building_text?.classList.add('fade-in');
                elements.building_img?.classList.add('card_fade-in');
            }

            if (y > 2300) {
                elements.resp_text?.classList.add('card_fade-in');
                elements.resp_logo?.classList.add('fade-in');
            }

            if (elements.socials) {
                elements.socials.style.animation =
                    y > 6700
                        ? "socialsFadeOut 1s ease forwards"
                        : "socialsFadeIn 1s ease forwards";
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);

    }, []);

    function nextImg() {

        let index = imgList.indexOf(buildingImg);

        const nextIndex = (index + 1) % imgList.length
        setBuildingImg(imgList[nextIndex]);

    }

    function prevImg() {

        let index = imgList.indexOf(buildingImg);

        const prevIndex = (index - 1 + imgList.length) % imgList.length
        setBuildingImg(imgList[prevIndex]);
    }


    return (
        <>


            <main>
                <div id="overlay" className="overlay"></div>
                <span id="socials" className="socials_SF">

                    <Link id="whatsapp" to="https://api.whatsapp.com/send?phone=5524999343720&text=Ol%C3%A1%20gostaria%20de%20marcar%20uma%20aula%20na%20Team%20Crezio!"><i class="bi bi-whatsapp"></i></Link>
                    <Link id="instagram" to="https://www.instagram.com/creziochaveslutas?igsh=NnF0dWEyNWs0NWRx"><i class="bi bi-instagram"></i></Link>
                </span>
                <div id="home_image" className="unit_building_SF">

                    <div className="unit_text_SF">

                        <h1 className="unit_text_SF_title fade-in">Crezio Lutas - SkyFit</h1>
                        <p className="fade-in">Treine com o time que tem história e metodologia desde 1958.</p>
                        <p className="fade-in">Aqui você encontra o treino que se encaixa com o seu objeto.</p>

                        <Link to="https://agendamento.nextfit.com.br/77fde85d-e306-4c60-bf10-4f398746bee3"> <button className="agenda_button_SF">Agende sua primeira aula grátis</button> </Link>


                    </div>
                    <img className="academia_SF" alt="academiaTeamCrezio" src={skyfitlogo}></img>

                    <img className="home_logo_SF" alt="logoTeamCrezio" src={teamcrezio}></img>


                </div>

                <div className="schedule">
                    <ul>
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                    </ul>
                    <img src={schedule} />

                </div>
                <div className="classes_models_SF">
                    <h1>Conheça Nossas Aulas</h1>
                    <p>Descubra todos os benefícios da Team Crezio</p>
                    <div className="lessons_SF">
                        <div id="begginner">
                            <img src={begginner} alt="aulaIniciante"></img>
                            <h2>Aulas para Iniciantes</h2>

                            <p style={{ fontStyle: "italic", fontWeight: "bold", marginBottom: "auto" }}>
                                Comece sua jornada no mundo das lutas!
                            </p>
                            <br />
                            <p>
                                Se você nunca treinou e quer dar os primeiros passos nesse universo, este é o seu lugar!

                            </p>
                            <br />
                            <p>
                                Oferecemos aulas personalizadas (professor x aluno) ou em grupos reduzidos, garantindo atenção individualizada para você evoluir: <br /> <br />
                                • Técnica desde o básico, com fundamentos sólidos.  <br />
                                • Condicionamento físico adaptado ao seu ritmo.  <br />
                                • Ambiente acolhedor  para aprender com segurança e confiança.
                            </p>
                            <br />
                            <p style={{ marginTop: "auto", fontStyle: "italic", fontWeight: "bold" }}>
                                Sua jornada começa aqui – venha treinar!
                            </p>
                        </div>

                        <div id="woman">
                            <img src={woman} alt="aulaMulher"></img>
                            <h2>Aulas para Mulheres</h2>

                            <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                Empoderamento, técnica e segurança – treine no seu ritmo!
                            </p>
                            <br />

                            <p>
                                Todas as aulas respeitam seu tempo e objetivos, com técnicas adaptadas e foco na sua evolução.<br /><br />
                                Quer começar a treinar em um ambiente acolhedor e seguro? Aqui, você pode:<br /><br />
                                • Iniciar com aulas individualizadas (professora x aluna) para ganhar confiança.<br />
                                • Evoluir para grupos exclusivos de mulheres, se preferir.<br />
                                • Participar de turmas mistas – você escolhe o que se sente melhor!<br />

                            </p>
                            <br />

                            <p style={{ marginTop: "auto", fontStyle: "italic", fontWeight: "bold" }}>
                                Venha descobrir sua força!
                            </p>

                        </div>

                        <div id="kid">
                            <img src={kids} alt="aulaCrianças"></img>
                            <h2>Aulas para Crianças</h2>
                            <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                Desenvolvendo habilidades, disciplina e diversão através das artes marciais!
                            </p>
                            <br />

                            <p>
                                Oferecemos um ambiente seguro e estimulante para seu filho(a) aprender enquanto se diverte:<br /><br />
                                • Aulas lúdicas – Jogos e atividades que ensinam os fundamentos das lutas de forma divertida<br />
                                • Foco em valores – Respeito, disciplina e trabalho em equipe<br />
                                • Professores especializados – Paciência e didática para ensinar crianças<br />
                                • Segurança em primeiro lugar – Ambiente controlado e equipamentos adequados<br />

                            </p>
                            <br />

                            <p style={{ marginTop: "auto", fontStyle: "italic", fontWeight: "bold" }}>
                                Idades a partir de 5 anos – turmas separadas por faixa etária
                            </p>
                        </div>

                        <div id="teacher">
                            <img src={teacher} alt="aulaInglês"></img>
                            <h2>Classes in English</h2>
                            <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                Train Authentic Brazilian Jiu-Jitsu – No Portuguese Needed!
                            </p>
                            <br />
                            <p>

                                Just arrived in Brazil and want to train? Here, you can:<br /><br />
                                • Learn from experienced instructors who teach in English<br />
                                • Join a welcoming community of local and international students<br />
                                • Experience real Brazilian Jiu-Jitsu – the way it’s meant to be trained!<br /><br />
                                Whether you're here long-term or just visiting, drop in and roll with us!

                            </p>
                            <br />
                            <p style={{ marginTop: "auto", fontStyle: "italic", fontWeight: "bold" }}>
                                No language barrier – just great Jiu-Jitsu.
                            </p>
                        </div>
                    </div>
                    <Link to="https://agendamento.nextfit.com.br/77fde85d-e306-4c60-bf10-4f398746bee3"> <button className="agenda_button_SF_class">Agende sua primeira aula grátis</button> </Link>
                </div>

                <div className="plans_SF">
                    <div>
                        <h1 className="plans_promo_title_SF">Plano mais vendido</h1>
                        <div className="plans_board_SF_Promo" id="planOptionsPromo">
                            {planos.map((plano, index) => {

                                const isPromo = plano.tipo.includes("recorrente");

                                if (isPromo) {

                                    return (
                                        <div className={`plan_options_SF ${isPromo ? "plan_options_SF_promo" : ""}`} key={index}>
                                            <div className="plan_title_SF">
                                                <h2 >{plano.modalidade}</h2>
                                                <h5>{plano.tipo}</h5>
                                            </div>

                                            <div className="plan_info_SF">
                                                <div>
                                                    <h3>TX.Adesão</h3>
                                                    <p>{plano.tx_adesão}</p>

                                                </div>
                                                <div>
                                                    <h3>Duração</h3>
                                                    <p>{plano.duração}</p>
                                                </div>
                                            </div>

                                            <div className="plan_info_SF">
                                                <div>
                                                    <h3>Pagamento</h3>
                                                    <p>{plano.pagamento}</p>
                                                </div>
                                                <div>
                                                    <h3 className="valor_h3_SF">Parcelas de</h3>
                                                    <p className="valor_SF">{plano.parcela}</p>
                                                    <h4>valor total {"R$" + plano.valorTotal + ",00"}</h4>
                                                </div>

                                            </div>
                                            <Link to={plano.source}><button className="select_plan_SF">comprar plano</button></Link>
                                            <h5 className="promoCard">Destaque</h5>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                        <h1 className="plans_promo_title_SF">Planos Comuns</h1>
                        <div className="plans_board_SF fading-scroll-container_SF" id="planOptions">
                            {planos.map((plano, index) => {

                                const isPromo = plano.tipo.includes("recorrente");

                                if (!isPromo) {

                                    return (
                                        <div className={`plan_options_SF ${isPromo ? "plan_options_SF_promo" : ""}`} key={index}>
                                            <div className="plan_title_SF">
                                                <h2 >{plano.modalidade}</h2>
                                                <h5>{plano.tipo}</h5>
                                            </div>

                                            <div className="plan_info_SF">
                                                <div>
                                                    <h3>TX.Adesão</h3>
                                                    <p>{plano.tx_adesão}</p>

                                                </div>
                                                <div>
                                                    <h3>Duração</h3>
                                                    <p>{plano.duração}</p>
                                                </div>
                                            </div>

                                            <div className="plan_info_SF">
                                                <div>
                                                    <h3>Pagamento</h3>
                                                    <p>{plano.pagamento}</p>
                                                </div>
                                                <div>
                                                    <h3 className="valor_h3_SF">Parcelas de</h3>
                                                    <p className="valor_SF">{plano.parcela}</p>
                                                    <h4>valor total {"R$" + plano.valorTotal + ",00"}</h4>
                                                </div>

                                            </div>
                                            <Link to={plano.source}><button className="select_plan_SF">comprar plano</button></Link>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                    <div className="plan_text_SF" id="planText">
                        <h1>Conheça Todos os Nossos Planos</h1>
                        <p>Aqui oferecemos os melhores planos, com promoções regulares para que adeque à sua preferência e que caiba no seu bolso</p>
                        <div className="choose_type_plan_SF">
                            <Link to="https://venda.nextfit.com.br/3e13b01f-f4c6-4571-9ee3-967fe417de96/contratos"><button className="type_plan_SF">Conheça todos os planos</button></Link>
                        </div>

                    </div>
                </div>



                <div className="teachers_SF">
                    <div className="teachers_SF_info" id="prof-p">
                        <h1>Nossos Professores</h1>
                        <p>Nossos professores seguem a metodologia Team Crezio.</p>
                        <p>No Estudio Team Crezio SP temos nosso coordenador faixa e preta graduado em Educação Física e a cada 2 semanas fazemos um rodízio dos professores do centro de lutas Team Crezio Petrópolis. Com esse rodizio os alunos podem aproveitar o melhor de cada instrutor do nosso time.</p>
                    </div>
                    <div id="prof-img">
                        <img className="teachers_img_SF" alt="grupoTeamCrezio" src={professores}></img>
                    </div>
                </div>



                <div className="building_SF">
                    <div className="building_SF_info" id="building_img">
                        <div className="building_images_SF">



                            <img className="building_img_SF" alt="img01" src={buildingImg}></img>

                            <div>
                                anter.
                                <i onClick={prevImg} class="bi bi-chevron-left"></i>
                                <i onClick={nextImg} class="bi bi-chevron-right"></i>
                                prox.
                            </div>
                        </div>

                    </div>
                    <div className="building_SF_info" id="building_text">
                        <h1>Nosso Espaço de Treino</h1>
                        <p>Nosso espaço é preparado e pensado para deixar você com uma estrutura de treinamento completa. Equipamento de treinamento completo e espaços multidisciplinares. Aqui oferecemos diferentes ambientes e serviços para os clientes. </p>
                        <div className="unit_offers_SP">
                            <i class="bi bi-bag">Produtos Crezio</i>
                            <i class="bi bi-backpack">Armários</i>
                            <i class="bi bi-activity">Academia</i>
                            <i class="bi bi-gender-ambiguous">Vestiários</i>

                        </div>
                    </div>
                </div>

                <div className="unit_responsable_SF">

                    <h1>Responsável da Unidade</h1>

                    <div className="unit_responsable_info_SF">
                        <div className="unit_responsable_imgs_SF">
                            <img id="eduardo" className="responsable_SF" alt="proprietarioTeamCrezioSP" src={responsable}></img>
                            <img id="resp_logo" className="responsable_logo_SF" alt="logoPretoTeamCrezio" src={responsable_logo}></img>
                        </div>

                        <div className="resp_text_SF" id="resp_text">
                            <h2>Miguel</h2>
                            <ul>
                                <li>- Educador Físico</li>
                                <li>- Faixa preta 3º Grau</li>

                            </ul>
                        </div>

                    </div>
                </div>

                <div className="studio_info_SF">
                    <h1>Conheça o Estúdio</h1>

                    <div className="maps_SF">
                        <div>
                            <img className="maps_img_SF" alt="bairroPompeia" src={academia}></img>
                            <p> - Localizada na - <br /> Estrada Philuvio Cerqueira Rodrigues, 2227, Itaipava, Petrópolis </p>
                            <Link to="https://linktr.ee/teamcrezio"><button className="SB_button_SF">Saiba Mais</button></Link>
                        </div>
                        <div>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3688.8592266420987!2d-43.125576123974994!3d-22.3966637796174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x99ab110937c1a7%3A0x1473f2bc2b1b8344!2sEstr.%20Philuvio%20Cerqueira%20Rodrigues%2C%202227%20-%20Itaipava%2C%20Petr%C3%B3polis%20-%20RJ%2C%2025745-070!5e0!3m2!1spt-BR!2sbr!4v1745525323728!5m2!1spt-BR!2sbr"
                                className="google_maps_SF"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>

            </main>

        </>
    )
}
